import React, { useState, createContext } from "react";
import { IUser, UserContextType } from './UserTypes'



interface Props {
    children: React.ReactNode;
}

export const abc = React.createContext(null);
export const LoginContext = React.createContext<UserContextType | null>(null);

const LoginProvider: React.FC<Props> = ({ children }) => {
    const [users, setUser] = React.useState<IUser>(
        {
            userType: '',
            userID: 0,
            token: '',
            IsAuthenticated: false,
            userTypeID: 0,
            email: '',
            dateCreated: '',
            name:''
        }

    );
    const saveUser = (user: IUser) => {
        const newUser: IUser = {
            userType: user.userType,
            token: user.token,
            userID: user.userID,
            IsAuthenticated: user.IsAuthenticated,
            userTypeID: user.userTypeID,
            email: user.email,
            dateCreated: user.dateCreated,
            name: user.name,
        };
        setUser(newUser);
    };
    const logoutUser = () => {
        const newUser: IUser = {
            userType: null,
            token: null,
            userID: null,
            IsAuthenticated: false,
            userTypeID: null,
            email: null,
            dateCreated: null,
            name:null,
        };
        setUser(newUser);
    };
    return <LoginContext.Provider value={{ users, saveUser, logoutUser }}>{children}</LoginContext.Provider>;
};

export default LoginProvider;









/*export const LoginContext = createContext({ user: { Token: '', UserName: '', UserType: 0 }, addUser: (Token: '', UserName: '', UserType: 0) => { } }); */
//export const LoginContextProvider = ({ children }: LoginProviderProps) => {
//    const [user, setUser] = useState({
//        Token: '', UserName: '', UserType: 0
//    })
//    const addUser = (Token: string, UserName: string, UserType: number) => {
//        setUser({ Token: Token, UserName: UserName, UserType: UserType });

//    }
//    return (
//        <LoginContext.Provider value={{ user, addUser }}>
//            {children}
//        </LoginContext.Provider>


//    )

//};


//import React, { useState, createContext } from "react";

//interface LoginProviderProps {
//    children: React.ReactNode
//}

//export const LoginContext = createContext({ loggedIn: false, setLoggedIn: (loggedIn: boolean) => { } });

//export const LoginProvider = ({ children }: LoginProviderProps) => {

//    const [loggedIn, setLoggedIn] = useState(false);

//    return (
//        <LoginContext.Provider value={{ loggedIn, setLoggedIn }}>
//            {children}
//        </LoginContext.Provider>
//    );
//};